import { TeamMembersPage } from "@fwa/src/components/TeamMembersPage";
import Head from "next/head";

const Page = () => (
  <>
    <Head>
      <meta name="robots" content="noindex" />
    </Head>
    <TeamMembersPage edit={false} />
  </>
);

export default Page;
